import GuestPreferences from '../ui/GuestPreferences';
import { connect } from 'react-redux';
import { hostProfileSubmit, skipSubmit, goBack, updateSchools } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    profileElements: state.profileElements,
    localProfileElements: state.localProfileElements,
    activeProfileElements: state.activeProfileElements,
    requiredFields: state.requiredFields,
    disableCovidQuestions: state.territory.disable_covid_questions
  });

const mapDispatchToProps = dispatch => ({
  onHostProfileSubmit(payload) {
    dispatch(
      hostProfileSubmit(payload)
    );
  },
  onSkipSubmit(payload) {
    dispatch(
      skipSubmit(payload)
    );
  },
  onGoBack(payload) {
    dispatch(
      goBack(payload)
    );
  },
  onUpdateSchools(payload) {
    dispatch(
      updateSchools(payload)
    );
  }
});

const Container = connect(mapStateToProps, mapDispatchToProps)(GuestPreferences);

export default Container;
